import { EmptyCard3 } from "@shadcn/pro-blocks/application/empty-sections/empty-section-4";
import { createFileRoute } from "@tanstack/react-router";
import { Container, Lock, Navigation, ReceiptText } from "lucide-react";
import { AppHeader } from "~/components/layout/AppHeader";
import { PageContainer } from "~/components/layout/PageContainer";

export const Route = createFileRoute("/support/how-to-use/donations")({
	beforeLoad: () => {
		document.title = 'bacehub | Chat & Support'
	},
	component: RouteComponent,
});

export default function RouteComponent() {
	return (
		<PageContainer>
			<AppHeader service="ALL" />
			<h1 className="text-2xl font-breit px-6 py-4">This is how donations works</h1>
			<div className="mx-6">
				<EmptyCard3 icon={Container} title="Select Size" description="Choose a space in size S, M, or L in the hub." />
				<EmptyCard3 icon={ReceiptText} title="Confirm donation" description="Confirm your space reservation." />
				<EmptyCard3 icon={Navigation} title="Go to the hub" description="Open your locker with the app." />
				<EmptyCard3 icon={Lock} title="Store & done" description="Place your items in the locker and close it." />
			</div>
		</PageContainer>
	);
}
